import React from 'react';
import { Button } from '@cld/button';
import { StyleButtonSeparator, StyledDownloadContainer } from '../App.styled';

export const ActionButtons = ({ assets, selectedPreset, cloudName }) => {

    const canDownload = !!selectedPreset;

    const onClick = async () => {
        await window.cloudinary.customAction.downloadItems({
            itemType: 'asset',
            ids: assets.map(({ id }) => id),
            options: {
                transformations: selectedPreset
            }
        });
    };

    const closeModal  = () => window.cloudinary.customAction.closeModal();

    return (
        <StyledDownloadContainer>
            <Button
                onClick={closeModal}
                size="md"
                variant="secondary"
            >
                Close
            </Button>
            <StyleButtonSeparator/>
            <Button
                disabled={!canDownload}
                onClick={onClick}
                size="md"
            >
                Download
            </Button>

        </StyledDownloadContainer>
    );
};
